import { TwilioRoomEvents, TwilioParticipantEvents } from '../../../twilio/constants';

export const TwilioActions = Object.freeze({
  UPDATE_CONNECTION_STATUS: 'UPDATE_CONNECTION_STATUS',
  UPDATE_ROOM: 'UPDATE_ROOM',
  UPDATE_VIDEO: 'UPDATE_VIDEO',
  UPDATE_AUDIO: 'UPDATE_AUDIO',
  TWILIO_PARTICIPANT_CONNECTED: 'TWILIO_PARTICIPANT_CONNECTED',
  TWILIO_PARTICIPANT_DISCONNECTED: 'TWILIO_PARTICIPANT_DISCONNECTED',
  TWILIO_TRACK_PUBLISHED: 'TWILIO_TRACK_PUBLISHED',
  TWILIO_TRACK_UNPUBLISHED: 'TWILIO_TRACK_UNPUBLISHED',
  TWILIO_TRACK_SUBSCRIBED: 'TWILIO_TRACK_SUBSCRIBED',
  TWILIO_TRACK_UNSUBSCRIBED: 'TWILIO_TRACK_UNSUBSCRIBED',
  TWILIO_TRACK_ENABLED: 'TWILIO_TRACK_ENABLED',
  TWILIO_TRACK_DISABLED: 'TWILIO_TRACK_DISABLED',
  TWILIO_LOCAL_TRACK_PUBLISHED: 'TWILIO_LOCAL_TRACK_PUBLISHED',
  TWILIO_LOCAL_TRACK_ENABLED: 'TWILIO_LOCAL_TRACK_ENABLED',
  TWILIO_LOCAL_TRACK_DISABLED: 'TWILIO_LOCAL_TRACK_DISABLED',
});

export const ConnectionStatus = {
  INITIAL: 'INITIAL',
  CONNECTING: 'CONNECTING',
  CONNECTED: 'CONNECTED',
  DISCONNECTED: 'DISCONNECTED',
  KICKED: 'KICKED',
};

export const setConnectionStatus = (status) => ({
  type: TwilioActions.UPDATE_CONNECTION_STATUS,
  payload: status,
});

export const setLocalVideoTrack = (track) => ({
  type: TwilioActions.UPDATE_VIDEO,
  payload: track,
});

export const setLocalAudioTrack = (track) => ({
  type: TwilioActions.UPDATE_AUDIO,
  payload: track,
});

export const setRoom = (room) => ({
  type: TwilioActions.UPDATE_ROOM,
  payload: room,
});

export const addListenersToRoom = (room) => (dispatch) => {
  room.on(TwilioRoomEvents.ParticipantConnected, (participant) => {
    dispatch({ type: TwilioActions.TWILIO_PARTICIPANT_CONNECTED, participant });
  });

  room.on(TwilioRoomEvents.ParticipantDisconnected, (participant) => {
    dispatch({ type: TwilioActions.TWILIO_PARTICIPANT_DISCONNECTED, participant });
  });

  room.on(TwilioRoomEvents.TrackPublished, (publication, participant) => {
    dispatch({
      type: TwilioActions.TWILIO_TRACK_PUBLISHED,
      publication,
      participant,
    });
  });

  room.on(TwilioRoomEvents.TrackUnpublished, (publication, participant) => {
    dispatch({
      type: TwilioActions.TWILIO_TRACK_UNPUBLISHED,
      publication,
      participant,
    });
  });

  room.on(TwilioRoomEvents.TrackSubscribed, (track, publication, participant) => {
    dispatch({
      type: TwilioActions.TWILIO_TRACK_SUBSCRIBED,
      track,
      publication,
      participant,
    });
  });

  room.on(TwilioRoomEvents.TrackUnsubscribed, (track, publication, participant) => {
    dispatch({
      type: TwilioActions.TWILIO_TRACK_UNSUBSCRIBED,
      track,
      publication,
      participant,
    });
  });

  room.on(TwilioRoomEvents.TrackEnabled, (publication, participant) => {
    dispatch({
      type: TwilioActions.TWILIO_TRACK_ENABLED,
      publication,
      participant,
    });
  });

  room.on(TwilioRoomEvents.TrackDisabled, (publication, participant) => {
    dispatch({
      type: TwilioActions.TWILIO_TRACK_DISABLED,
      publication,
      participant,
    });
  });

  room.localParticipant.on(TwilioParticipantEvents.TrackPublished, (publication) => {
    dispatch({
      type: TwilioActions.TWILIO_LOCAL_TRACK_PUBLISHED,
      publication,
    });
  });

  room.localParticipant.on(TwilioParticipantEvents.TrackEnabled, (track) => {
    dispatch({
      type: TwilioActions.TWILIO_LOCAL_TRACK_ENABLED,
      track,
    });
  });

  room.localParticipant.on(TwilioParticipantEvents.TrackDisabled, (track) => {
    dispatch({
      type: TwilioActions.TWILIO_LOCAL_TRACK_DISABLED,
      track,
    });
  });
};

const INIT_STATE = {
  status: ConnectionStatus.INITIAL,
  room: null,
  videoTrack: null, // if disconnected, these may not be available through room instance
  audioTrack: null, // if disconnected, these may not be available through room instance
};

export const twilioReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case TwilioActions.UPDATE_CONNECTION_STATUS: {
      return { ...state, status: action.payload };
    }
    case TwilioActions.UPDATE_ROOM: {
      return { ...state, room: action.payload };
    }
    case TwilioActions.UPDATE_VIDEO: {
      return { ...state, videoTrack: action.payload };
    }
    case TwilioActions.UPDATE_AUDIO: {
      return { ...state, audioTrack: action.payload };
    }
    case TwilioActions.TWILIO_PARTICIPANT_CONNECTED:
    case TwilioActions.TWILIO_PARTICIPANT_DISCONNECTED:
    case TwilioActions.TWILIO_TRACK_PUBLISHED:
    case TwilioActions.TWILIO_TRACK_UNPUBLISHED:
    case TwilioActions.TWILIO_TRACK_SUBSCRIBED:
    case TwilioActions.TWILIO_TRACK_UNSUBSCRIBED:
    case TwilioActions.TWILIO_TRACK_ENABLED:
    case TwilioActions.TWILIO_TRACK_DISABLED:
    case TwilioActions.TWILIO_LOCAL_TRACK_PUBLISHED:
    case TwilioActions.TWILIO_LOCAL_TRACK_ENABLED:
    case TwilioActions.TWILIO_LOCAL_TRACK_DISABLED:
      // do nothing, state is manager by twilio (inside room instance)
      return state;

    default:
      return state;
  }
};
